import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Modal, Checkbox, Toast } from 'antd-mobile';
import copy from 'copy-to-clipboard';
import './index.scss';
import { isPhone } from '../../utils/common';
const CheckboxItem = Checkbox.CheckboxItem;
let isMobile = false;
if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
	//移动端
	isMobile = true;
}
export const DownloadTip = props => {
	let { isDownloadTip, imgInfo, index, onClose, onOpenTipNext } = props;
	let [checkedIndex, setCheckedIndex] = useState(0);
	let [checkedUrl, setCheckedUrl] = useState('');
	let [isTooBig, setIsTooBig] = useState(false);
	if (!imgInfo || !imgInfo[index]) {
		return null;
	}
	let item = imgInfo[index];
	let { width, height, size, originalUrl, darkOriginalUrl, midUrl, url, type } = item;
	function filterSize(size) {
		if (size > 1024 * 1024 * 1024 * 1024) {
			return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB';
		} else if (size > 1024 * 1024 * 1024) {
			return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
		} else if (size > 1024 * 1024) {
			return (size / 1024 / 1024).toFixed(2) + ' MB';
		} else if (size > 1024) {
			return (size / 1024).toFixed(2) + ' KB';
		}
		return size.toString() + ' B';
	}
	let arrData = [];
	function onChange(val) {
		console.log(val);
		if (checkedIndex === val) {
			setCheckedIndex('');
			setCheckedUrl('');
		} else {
			setCheckedIndex(val);
			setCheckedUrl(arrData[val].url);
		}
	}
	function VideoOrPic() {
		let fileType = originalUrl.substring(originalUrl.lastIndexOf('.') + 1).toUpperCase();
		fileType = fileType === 'JPEG' ? 'JPG' : fileType;
		if (type === 2) {
			let size1 = filterSize(size);
			arrData = [{ width, height, size: size1, url: originalUrl, type: '超清', beforeSize: size }];
		} else {
			let width1 = 3840;
			let width2 = 1920;
			let width3 = 1080;
			let height1 = parseInt((width1 * height) / width, 10);
			let height2 = parseInt((width2 * height) / width, 10);
			let height3 = parseInt((width3 * height) / width, 10);
			let size1 = parseInt((width1 * size) / width, 10);
			let size2 = parseInt((width2 * size) / width, 10);
			let size3 = parseInt((width3 * size) / width, 10);
			let filterSize1 = filterSize(size1);
			let filterSize2 = filterSize(size2);
			let filterSize3 = filterSize(size3);
			arrData = [
				{ width: width3, height: height3, size: filterSize3, url, type: '小图', beforeSize: size3 },
				{ width: width2, height: height2, size: filterSize2, url: midUrl, type: '中图', beforeSize: size2 },
				{ width: width1, height: height1, size: filterSize1, url: darkOriginalUrl || originalUrl, type: '大图', beforeSize: size1 }
			];
		}
		return (
			<div>
				{arrData.map((item, index) => {
					return (
						<div key={index} className={'download-tr ' + (index === checkedIndex ? 'active' : '')}>
							<div className="w-20">
								<CheckboxItem key={index} defaultChecked={index === checkedIndex} onChange={() => onChange(index)}></CheckboxItem>
							</div>
							<div className="w-25">
								<div className="pic-type">{fileType}</div>
							</div>
							<div className="w-30">
								{item.type} {item.width}x{item.height}
							</div>
							<div className="w-25">{item.size}</div>
						</div>
					);
				})}
			</div>
		);
	}
	function closest(el, selector) {
		const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
		while (el) {
			if (matchesSelector.call(el, selector)) {
				return el;
			}
			el = el.parentElement;
		}
		return null;
	}
	function onWrapTouchStart(e) {
		if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
			return;
		}
		const pNode = closest(e.target, '.am-modal-content');
		if (!pNode) {
			e.preventDefault();
		}
	}
	function PhotoOptions() {
		return (
			<div className="download-body">
				<div className="download-th">
					<div className="w-20">选择</div>
					<div className="w-25">格式</div>
					<div className="w-30">像素</div>
					<div className="w-25">大小</div>
				</div>
				<VideoOrPic />
				<div className="download-footer">
					<span onClick={nextHandle}>继续</span>
				</div>
			</div>
		);
	}
	function TooBigTip() {
		return (
			<div className="download-body">
				<div className="download-tip">文件过大，请点击复制下方链接用电脑端下载。</div>
				<div className="download-url" onClick={onCopy}>
					{checkedUrl}
				</div>
				<div className="download-confirm">
					<span onClick={confirmCopy}>确定</span>
				</div>
			</div>
		);
	}
	function confirmCopy() {
		onCopy();
		onClose();
	}
	function nextHandle() {
		if (checkedIndex === '') {
			Toast.info('请选择要下载的格式');
			return;
		}
		if (!checkedUrl && checkedIndex !== '') {
			setCheckedUrl(arrData[checkedIndex].url);
		}
		let size = arrData[checkedIndex].beforeSize;
		if (size > 25 * 1024 * 1024) {
			setIsTooBig(true);
			return;
		}
		onOpenTipNext(arrData[checkedIndex].url);
	}
	function onCopy() {
		if (!checkedUrl && checkedIndex !== '') {
			setCheckedUrl(arrData[checkedIndex].url);
		}
		copy(checkedUrl);
		Toast.success('复制成功');
	}
	return (
		<Modal className="download-modal" visible={isDownloadTip} maskClosable transparent onClose={onClose} title={isTooBig ? '提示' : '下载选项'} wrapProps={{ onTouchStart: onWrapTouchStart }}>
			{isTooBig ? <TooBigTip /> : <PhotoOptions />}
		</Modal>
	);
};
